"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryCircuitEntity = void 0;
const swagger_1 = require("@nestjs/swagger");
class CategoryCircuitEntity {
    /**
     * @deprecated
     */
    _id;
    id;
    name;
    categoryIds;
    tagIds;
    displayIds;
    color;
    background;
    image;
    description;
    order;
    featured;
    is_archived;
    createdAt;
    updatedAt;
}
exports.CategoryCircuitEntity = CategoryCircuitEntity;
__decorate([
    (0, swagger_1.ApiPropertyOptional)({ deprecated: true }),
    __metadata("design:type", String)
], CategoryCircuitEntity.prototype, "_id", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ description: "Unique identifier for the category circuit" }),
    __metadata("design:type", String)
], CategoryCircuitEntity.prototype, "id", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ description: "Human-readable category circuit name" }),
    __metadata("design:type", String)
], CategoryCircuitEntity.prototype, "name", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ description: "Display category ids included in this circuit", type: [String] }),
    __metadata("design:type", Array)
], CategoryCircuitEntity.prototype, "categoryIds", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ description: "Display tag ids included in this circuit", type: [String] }),
    __metadata("design:type", Array)
], CategoryCircuitEntity.prototype, "tagIds", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ description: "Concrete display ids included in this circuit", type: [String] }),
    __metadata("design:type", Array)
], CategoryCircuitEntity.prototype, "displayIds", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({ description: "Accent color for this circuit", example: "#7c3aed" }),
    __metadata("design:type", String)
], CategoryCircuitEntity.prototype, "color", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "CSS gradient/background string for this circuit",
        example: "linear-gradient(135deg, #7c3aed 0%, #06b6d4 100%)",
    }),
    __metadata("design:type", String)
], CategoryCircuitEntity.prototype, "background", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({ description: "Image URL for this circuit" }),
    __metadata("design:type", String)
], CategoryCircuitEntity.prototype, "image", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({ description: "Circuit description" }),
    __metadata("design:type", String)
], CategoryCircuitEntity.prototype, "description", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ description: "Sort order. Lower numbers appear first", default: 0 }),
    __metadata("design:type", Number)
], CategoryCircuitEntity.prototype, "order", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ description: "Whether this circuit is highlighted", default: false }),
    __metadata("design:type", Boolean)
], CategoryCircuitEntity.prototype, "featured", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ description: "Whether this circuit is archived", default: false }),
    __metadata("design:type", Boolean)
], CategoryCircuitEntity.prototype, "is_archived", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ description: "Creation timestamp" }),
    __metadata("design:type", String)
], CategoryCircuitEntity.prototype, "createdAt", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ description: "Last update timestamp" }),
    __metadata("design:type", String)
], CategoryCircuitEntity.prototype, "updatedAt", void 0);
